var req = require("!!/app/node_modules/pug-loader/index.js??ref--12-1!/app/src/linagora.esn.resource/app/components/resource-icon-picker/resource-icon-picker.pug");
module.exports = (req['default'] || req).apply(req, [])